// extracted by mini-css-extract-plugin
export default {"image":"styles_image__U-nQw","popper":"styles_popper__5JGCR","popperBody":"styles_popperBody__KffGa","frequency":"styles_frequency__rgtFj"};